import ErrorAlert from "../components/ErrorAlert";
import LoadingState from "../components/LoadingState";
import PageTitle from "../components/PageTitle";
import useOrders from "../hooks/useOrders";
import OrderFilters from "./OrderFilters";
import OrdersTable from "./OrdersTable";

export default function OrdersPage({ filters, onFilterChange, onNavigate }) {
  const {
    error,
    isLoading,
    orders,
    reloadOrders,
    updateOrderStatus,
  } = useOrders(filters);

  return (
    <main className="admin-page flex flex-column gap-5">
      <PageTitle eyebrow="Orders" title="Order Management">
        Filter, inspect, and safely update order status.
      </PageTitle>

      <OrderFilters filters={filters} onFilterChange={onFilterChange} />

      {error ? <ErrorAlert error={error} onRetry={reloadOrders} /> : null}
      {isLoading ? <LoadingState /> : null}

      {!isLoading && !error ? (
        <section className="card admin-panel">
          <header className="card-header">
            <h2>Orders</h2>
          </header>
          <div className="card-body">
            <OrdersTable
              orders={orders}
              onOpenOrder={(orderId) => onNavigate(`/admin/orders/${orderId}`)}
              onStatusChange={updateOrderStatus}
            />
          </div>
        </section>
      ) : null}
    </main>
  );
}